import { useState } from 'react';
import { useParams } from 'react-router-dom';
import Portlet from '../../../app/components/portlet/Portlet';
import PortletBody from '../../../app/components/portlet/PortletBody';
import { useGetAllCompanySettingsQuery } from '../../company/companyApiSlice';
import DynamicFormSection from '../components/DynamicFormSection';
import { StyledLabel } from '../../../assets/styledComponents/Global';
import theme from '../../../utils/themes';
import TrashIcon from '../../../app/components/svgIcons/TrashIcon';

const ThirdPartyListingContainer = () => {
  const { compId } = useParams();

  const initialFilters = {
    perPage: 5,
    page: 1,
    sortedColumn: { path: 'createdAt', order: 'DESC' },
    query: '',
  };

  const [listing, setListing] = useState({ ...initialFilters });

  const { data: settingsRes, refetch, isFetching, error } = useGetAllCompanySettingsQuery({
    params: {
      perPage: listing.perPage,
      page: listing.page,
      query: listing.query && listing.query,
      sort: listing.sortedColumn.path,
      sortDir: listing.sortedColumn.order,
    },
    id: compId
  });

  // Example dynamic data array
  const dynamicSections = [
    {
      title: 'RefNow',
      buttonLabel: settingsRes?.total === 5 ? '' : 'Connect',
      buttonType: settingsRes?.total === 5 ? 'text' : 'primary',
      buttonIcon: settingsRes?.total === 5 ? <TrashIcon size={20}/> : undefined,
      labelText: settingsRes?.total === 5 ? 'Connected' : undefined,
      onButtonClick: (values) => alert(JSON.stringify(values, null, 2)),
      fields: [
        { label: 'API Key', name: 'apiKey' },
        { label: 'Field1', name: 'field1' },
        { label: 'Field2', name: 'field2' },
      ],
    },
    {
      title: 'uCheck',
      buttonLabel: settingsRes?.total != 5 ? '' : 'Connect',
      buttonType: settingsRes?.total != 5 ? 'text' : 'primary',
      buttonIcon: settingsRes?.total != 5 ? <TrashIcon size={20}/> : undefined,
      onButtonClick: (values) => alert(JSON.stringify(values, null, 2)),
      fields: [
        { label: 'API Key', name: 'apiKey', required: true },
        { label: 'Field1', name: 'field1', required: true },
        { label: 'Field2', name: 'field2' },
      ],
    },
  ];

  return (
    <div>
      <Portlet>
        <div className="portlet__body-bg">
          <PortletBody>
            <>
            <div className='d-flex flex-column pt-3 pb-4'>
            <StyledLabel size={'20px'} weight={600} color={theme.headingColor}>Third Party Applications</StyledLabel>
                <StyledLabel size={'14px'} weight={400} color={theme.headingColor}>Integrate your account with external applications to enhance your workflow</StyledLabel>
          </div>
              {dynamicSections?.map((section, idx) => (
                <DynamicFormSection
                  key={idx}
                  sectionTitle={section?.title}
                  buttonLabel={section?.buttonLabel}
                  onButtonClick={(values) => {section?.onButtonClick(values)}}
                  fieldsData={section?.fields}
                  buttonType={section?.buttonType}
                  buttonIcon={section?.buttonIcon}
                  labelText= {section?.labelText}
                />
              ))}
            </>
          </PortletBody>
        </div>
      </Portlet>
    </div>
  );
};


export default ThirdPartyListingContainer;
